import { TOAST_TIMEOUT } from "../../config/constants";

export const Toast = {
  initial: () => initial(),
  from: (data) => from(data),
  close: (data) => close(data),
};

const initial = () => ({
  open: false,
  severity: "error",
  content: "",
  duration: TOAST_TIMEOUT,
});

const from = (data) => ({
  open: true,
  severity: data?.severity,
  content: data?.content,
  duration: data?.duration ?? TOAST_TIMEOUT,
});

const close = (data) => ({
  open: false,
  severity: data?.severity,
  content: data?.content,
  duration: data?.duration ?? TOAST_TIMEOUT,
});
